import script from "./TrustPilot.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrustPilot.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__